import { useQuery } from '@tanstack/react-query';
import {
  IAutoAddingProduct,
  IComboGroup,
  IFavourites,
  IMenuProduct,
  IProductModifiers,
} from '../_types';
import { request } from './http-client';
import { TParams } from './types';
import { IProduct } from '@/entities/product/model/types';

const productService = {
  getAll: (params: TParams, shipper_id?: string, platform_id?: string, token?: string) =>
    request.get<{ products: IProduct[]; count: number }>('/v2/product', {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
        Authorization: token,
      },
    }),

  getById: (
    id: string,
    params: TParams,
    shipper_id?: string,
    platform_id?: string,
  ) =>
    request.get<IProduct>(`/v2/product/${id}`, {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    }),

  getComboById: (id: string, params: TParams) =>
    request.get<{ groups: IComboGroup[] }>(`/v2/combo/${id}`, { params }),

  getMenuProducts: (params: TParams, shipper_id?: string) =>
    request.get<{ products: IMenuProduct[] }>(`/v3/menu-products`, {
      params,
      headers: {
        Shipper: shipper_id,
      },
    }),

  getAutoAddProduct: (params: TParams, shipper_id: string) =>
    request.get<{
      count: number | string;
      products: IAutoAddingProduct[];
    }>(`/v3/auto-add-product`, {
      params, headers: {
        Shipper: shipper_id,
      },
    }),

  getProductFavourites: (
    params: TParams,
    shipper_id?: string,
    platform_id?: string,
  ) =>
    request.get<IFavourites>(`/v2/product-favourites`, {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    }),
};

export const getProductModifier = (params: any) =>
  request.get<{
    product_modifiers: IProductModifiers;
    count: string | number;
  }>('/v2/modifier', { params });

export default productService;

export const useProductList = ({
  params,
  props = { enabled: false },
}: {
  params: TParams;
  props: any;
}) => {
  return useQuery<{ products: IProduct[]; count: string }, Error>({
    queryKey: ['product_list', props, params],
    queryFn: () => productService.getAll(params).then((res) => res?.data),
    ...props,
  });
};
